import useModal from 'hooks/useModal';
import { useTranslation } from 'react-i18next';
import { PortModel } from 'models/PortModel';
import usePorts from 'modules/yards/hooks/usePorts';
import PortDialog from 'modules/yards/dialogs/PortDialog';


const usePortModals = () => {
    const {t} = useTranslation();
    const {showModal, hideModal} = useModal();
    const {updatePort, createPort} = usePorts();

    const openAddPortModal = (isLoading: boolean) => showModal(PortDialog,
        {
            create: true,
            port: {country: isLoading ? 'JP' : 'RU', isLoading} as PortModel
        },
        {title: t('add_title', {value: t('port')})})
        .then(port => createPort({...port, isLoading}))
        .then(id => {
            hideModal();
            return id;
        });

    const openEditPortModal = (port: PortModel) => showModal(PortDialog,
        {port},
        {
            title: t('edit_title', {value: t('port')})
        })
        .then(port => updatePort(port))
        .then(hideModal);

    return {
        openAddPortModal,
        openEditPortModal,
    };
};

export default usePortModals;
